import { CheckCircle2, TriangleAlert, X } from 'lucide-react';
import { useEffect } from 'react';

import { cn } from '@/shared/utils/cn';

import { toast, useToastStore } from './toast';

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);

  useEffect(() => {
    const timers = toasts.map((t) =>
      window.setTimeout(() => {
        toast.dismiss(t.id);
      }, t.durationMs),
    );

    return () => {
      timers.forEach((id) => window.clearTimeout(id));
    };
  }, [toasts]);

  if (toasts.length === 0) return null;

  return (
    <div
      aria-live="polite"
      aria-relevant="additions removals"
      className="pointer-events-none fixed right-4 top-4 z-[110] flex w-full max-w-sm flex-col gap-2"
    >
      {toasts.map((t) => {
        const isSuccess = t.variant === 'success';
        const Icon = isSuccess ? CheckCircle2 : TriangleAlert;
        return (
          <div
            key={t.id}
            className={cn(
              'pointer-events-auto flex items-start gap-3 rounded-lg border bg-surface p-3 shadow-[0px_10px_25px_-10px_rgba(0,0,0,0.25)]',
              isSuccess ? 'border-emerald-200' : 'border-border',
            )}
            role="status"
          >
            <div
              className={cn('mt-0.5', isSuccess ? 'text-emerald-600' : 'text-amber-600')}
              aria-hidden="true"
            >
              <Icon className="h-5 w-5" strokeWidth={2} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="break-words text-sm font-semibold text-fg">{t.title}</div>
              {t.description ? (
                <div className="mt-0.5 break-words whitespace-pre-wrap text-xs text-fg-muted">
                  {t.description}
                </div>
              ) : null}
            </div>
            <button
              type="button"
              onClick={() => toast.dismiss(t.id)}
              className={cn(
                'inline-flex h-8 w-8 items-center justify-center rounded-md text-fg-subtle',
                'hover:bg-surface-muted hover:text-fg',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
              )}
              aria-label="Close notification"
            >
              <X className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
